module.exports = __webpack_public_path__ + "img/alt.c8703cfc.svg";